<template>
  <div>
    <div class="text-center">
      <v-btn
        v-if="isSEITOrRSAdmin && activePlans.length == 0 && !creating"
        @click="creating = true"
        small
        color="primary"
        rounded
        outlined
        class="ma-4"
      >
        <v-icon small>mdi-plus</v-icon> New Plan
      </v-btn>
    </div>

    <!-- New plan (standalone editor) -->
    <plan-editor
      v-if="creating"
      :plan="null"
      @saved="creating = false"
      @cancel="creating = false"
    ></plan-editor>

    <plans-list
      v-if="activePlans.length > 0"
      :plans="activePlans"
      :active="true"
    ></plans-list>
    <div class="text-center my-3">
      <v-btn
        v-if="activePlans.length > 0 && previousPlans.length > 0"
        @click="showPrevious = !showPrevious"
        text
        small
        color="primary"
        >{{
          Boolean(showPrevious) ? "Hide Previous Plans" : "Show Previous Plans"
        }}</v-btn
      >
    </div>
    <plans-list
      v-if="activePlans.length == 0 || showPrevious"
      :plans="previousPlans"
    ></plans-list>
  </div>
</template>

<script>
import PlanEditor from "./plan-editor";
import PlansList from "./plans-list";
export default {
  components: { PlanEditor, PlansList },
  data() {
    return {
      panels: null,
      showPrevious: false,
      creating: false,
    };
  },
  computed: {
    isSEITOrRSAdmin() {
      return this.$store.getters["securityModule/isSEITOrRSAdmin"];
    },
    activePlans() {
      return this.clientPlans.filter((item) => item.isActive == true) || null;
    },
    clientPlans() {
      return (
        this.$store.state.plansModule.plans.slice().sort((a, b) => {
          return new Date(b.planStartDate) - new Date(a.planStartDate);
        }) || []
      );
    },
    previousPlans() {
      return this.clientPlans.filter((x) => !x.isActive);
    },
  },
};
</script>
